import React from "react";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import ListProductRequestOutgoingChild from "./ListProductRequestOutgoingChild";

const ListProductRequestOutgoing = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="PurchaseRequests" route="/outgoing-requests">
        <ListProductRequestOutgoingChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default ListProductRequestOutgoing;
